//
//  mys.enums.ts
//  IntelliJ IDEA
//
//  Created by mahdiyousefpour | +989123964349 on 12/3/20 - Thursday-December-2020.
//  Copyright © 2020 mahdiyousefpour. All rights reserved.
//

export const MenuName = {
    home: 'HOME',
    article: 'ARTICLE',
    appconfig: 'APPCONFIG',
    ticket: 'TICKET',
    activationcode: 'ACTIVATIONCODE',
    staticpages: 'STATICPAGES',
    message: 'message',
    advertisement: 'ADVERTISEMENT',
    expert: 'EXPERT',
    menu: 'MENU',
    product: 'PRODUCT',
    expertlocation: 'EXPERTLOCATION',
    news: 'NEWS',
    newstype: 'NEWSTYPE',
    newstypes: 'NEWSTYPES',
    aboutUs: 'ABOUTUS',
    contactus: 'contactUS',
    favorite: 'FAVORITE',
    blog: 'BLOG',
    task: 'task',
    profile: 'PROFILE',
    brand: 'BRAND',
    privacypolicy: 'privacypolicy',
    notification: 'notification',
    category: 'CATEGORY',
    comment: 'COMMENT',
    payment: 'PAYMENT',
    post: 'POST',
    location: 'LOCATION',
    group: 'GROUP',
    property: 'PROPERTY',
    user: 'USER',
    permission: 'PERMISSION',
    tourleader: 'TOURLEADER',
    sourcecategory: 'SOURCECATEGORY',
    sourceproperty: 'SOURCEPROPERTY',
    entityproperty: 'ENTITYPROPERTY',
    experttype: 'EXPERTTYPE',
    expertproperty: 'EXPERTPROPERTY',
    locationproperty: 'LOCATIONPROPERTY',
    locationtype: 'LOCATIONTYPE',
    newsletter: 'NEWSLETTER',
    coupon: 'COUPON',
    tag: 'TAG',
    restaurant: 'RESTAURANT',
    slider: 'SLIDER',
    order: 'ORDER',
    title: 'TITLE',
    job: 'JOB',
    city: 'CITY',
    sitesocial: 'SITESOCIAL',
    faq: 'FAQ',
    ourteam: 'OURTEAM',
    ourclient: 'OURCLIENT',
    customermessage: 'CUSTOMERMESSAGE',
    websiteservice: 'WEBSITESERVICE',
    orderitem: 'ORDERITEM',
    orderstatus: 'ORDERSTATUS',
    orderdetail: 'ORDERDETAIL',
    price: 'PRICE',
    employee: 'EMPLOYEE',
    customer: 'CUSTOMER',
    role: 'ROLE',
    discount: 'DISCOUNT',
    discounttype: 'DISCOUNTTYPE',
    salary: 'SALARY',
    salarydetail: 'SALARYDETAIL',
    playlist: 'PLAYLIST',
    live: 'LIVE',
    // menu : 'MENU',
    // menu : 'MENU'
}
